import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {XauditModel} from '../../../models/xaudit.model';

export class TreatmentFracturesModel extends XauditModel {
  TreatmentFracturesID: string;
  PatientId: string;
  CaseWorkItemToothId: string;
  enumEndoFractureLocationID: string;
  enumEndoFractureTypeID: string;
  enumEndoFractureExtensionID: string;
  enumEndoFractureTransilluminationID: string;

  /*tooth;

  // ValidValueItemIds
  location: EnumValidValueItemModel;
  type: EnumValidValueItemModel;
  extension: EnumValidValueItemModel;
  transIllumination: EnumValidValueItemModel;*/
}
